module.exports = "/wwwroot/img/do_or_dont_do_block_item.png?ver=b5c49770";